import Modal from '@anwb/poncho/components/modal';

import { ContractOverviewItems } from './ContractOverviewModalItems';

import StyledDescriptionList from './styles/overviewDescriptionList.styled';

type Props = {
	open: boolean;
	setOpen: (open: boolean) => void;
};

export const ContractOverviewModal = ({ open, setOpen }: Props) => (
	<Modal
		variant="passive"
		title="Het Private Lease contract van ANWB"
		size="l"
		open={open}
		onOpenChange={() => setOpen(false)}
	>
		<StyledDescriptionList items={ContractOverviewItems} />
	</Modal>
);
